import React , {useState , useEffect} from "react";
import Storage from "/src/utils/storage";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import SideModal from '/src/components/modal/SideModal/SideModal'
import useModalHelper from "/src/components/modal/hooks/useModalHelper";

import RolePermissionModalBody from "./RolePermissionModalBody"
import "./RolePermissionModal.css"
import "/src/assets/css/polices.css";
import roleService from "../../../services/roleService";

const RolePermissionModal = NiceModal.create(({ title, role }) => {
  
    const currentUser = Storage('local').get('user');

    const modal = useModal();

    const { onClose } = useModalHelper(modal);

    const { getPermissions } = roleService;

    const [permissions, setPermissions] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const [response, errors] = await getPermissions(role.id);
                if (errors != null) {
                    console.log(errors);
                    return;
                }
                setPermissions(response); 
                setLoading(false);
            } catch (error) {
                console.error("Error fetching permissions:", error);
                setLoading(false);
            }
        };

        fetchPermissions(); 
    }, [role.id]);

    // A SUPPRIMER : form | pas utilise pour le moment car user modal body pas utilisee
    // const form = { id: data == undefined ? null : data.id, username: data == undefined ? null : data.slug, is_admin: data == undefined ? null : data.is_admin, title: title, email: data == undefined ? null : data.email, company_name: data == undefined ? null : data.company.name, company_id : data == undefined ? null : data.company_id, picture: data == undefined ? null : data.picture }
   
    return (
        <SideModal name="change-password" id={modal.id} autoClose="true" onClose={onClose}>
            <div>
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })}  >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
           
            {!loading && <RolePermissionModalBody data={permissions} title={title} role={role} ></RolePermissionModalBody>}
               
        </SideModal >
    )
});

export default RolePermissionModal;